import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import { Control, LocalForm, Errors } from 'react-redux-form';

const ModalExample2 = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle
    // repos,
    // changeStagingprj,
    // setRepo,
    // setRepos
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("SQL/NoSQL Data Source");
  const [warningText, setWarningText] = useState("Exception");
  const [showEditor, setShowEditor] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [projectName, setProjectName] = useState("");
 // const [repo, setRepo] = useState("");
  const [customer, setCustomer] = useState("");
  const [stagingrepo, setStagingrepo] = useState("");
  const [refId, setRefId] = useState("");
  const [srclang, setSrclang] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("");
  const [description, setDescription] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [uploadcontent, setUploadcontent] = useState("");
  const [disableUploadBack, setDisableUploadBack] = useState("");
  const [disableupload, setDisableupload] = useState(false);
  const jobType = "Translation";
  const [customersList, setCustomersList] = useState(["com.mysql.jdbc.Driver","com.microsoft.sqlserver.jdbc.SQLServerDriver"]);

  const selectCus = (e)=>{
    setCustomer(e.target.value);
    //props.customersPrjList("Translation",e.target.value);
  };

  const toggle = () => setModal(!modal);

  const close = ()=>{
    toggle();
    //changeStagingprj()
  }


  useEffect(() => {

  }, []);

  return (

    <i>
      <Button className="button asse_upload" style={{backgroundColor:"#5e7a2b", marginBottom:'5px',height:'42px',width:'120px'}} onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            {(info || confirmation) &&(<div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/><i>{infoText}</i> </div>)}
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>{warningText} </div>)}
          </ModalHeader>
        )}
        <ModalBody>
          {/* {repos.map((item,i) => (
            <div key={i}>
              <input type="checkbox" checked={item.checked} key={i} onChange={()=>{item.checked = !item.checked; setRepos(repos)}} />{' '}
              {item.value}
            </div>
          ))} */}

<LocalForm
                    className="form"
                    onSubmit={() =>
                      props.clickSubmitHandler(
                        props.username
                        // props.repo,
                        // srclang,
                        // targetLanguage,
                        // description,
                        // jobType,
                        // stagingrepo,
                        // customer,
                                           
                      )
                    }
                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="jdbc.driver1"
                            defaultMessage="Pick an User"
                          />
                        </label>

                        <Control.select
                          model=".customer"
                          autoFocus
                          required
                          value={customer}
                         // onChange={selectCus}
                        //  onChange = {(e)=>{setMesssage(e.target.value)}}
                        >
                          {(customer === "" || customer === null) && <option value="">Please select a user</option>}
                          {customersList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Control.select>
                      </fieldset>
                      </div>
      </LocalForm>
        </ModalBody>
        <ModalFooter>
          {(info || warning) &&(
            <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={close}
            >
              <FormattedMessage id="nav.ok" defaultMessage="OK" />
            </button>
          )}
        </ModalFooter>
      </Modal>
    </i>
  );
}

export default ModalExample2;



// WEBPACK FOOTER //
// ./src/components/views/ManagementDFuser/popaddexistinguser.js